function kioskAddDiscountForm () {
    return {
        type: 'amount',
        value: null,
        duration: 'once',
        months: null
    };
}

var base = require('kiosk/add-discount');

Vue.component('spark-kiosk-add-discount', {
    mixins: [base],

    /**
     * The component's data.
     */
    data() {
        return {
            loadingCurrentDiscount: false,
            currentDiscount: null,

            discountingUser: null,
            form: new SparkForm(kioskAddDiscountForm()),
            discount_modal: null
        };
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        var self = this;

        Bus.$on('addDiscount', function (user) {
            self.form = new SparkForm(kioskAddDiscountForm());

            self.setUser(user);

            self.discount_modal = true;
        });
    },

    methods: {

        /**
         * Apply the discount to the user.
         */
        applyDiscount() {
            var self = this;
            Spark.post('/spark/kiosk/users/discount/' + this.discountingUser.id, this.form)
                .then(() => {
                    self.discount_modal = false;
                });
        }
    }
});
